import { useEffect, useRef, useState } from 'react';

const determineDropdownPosition = (dropdownRef, containerRef) => {
  if (!dropdownRef?.current || !containerRef?.current) return 'bottom';

  const dropdownHeight = dropdownRef.current.offsetHeight;
  const containerRect = containerRef.current.getBoundingClientRect();
  const dropdownRect = dropdownRef.current.getBoundingClientRect();

  const spaceBelow = containerRect.bottom - dropdownRect.top; // Рахуємо простір вниз
  const spaceAbove = dropdownRect.top - containerRect.top; // Рахуємо простір вгору

  if (spaceBelow >= dropdownHeight) {
    return 'bottom';
  }

  if (spaceAbove >= dropdownHeight) {
    return 'top';
  }

  return 'bottom';
};

export const useFieldDropdownPosition = ({
  containerRef,
  dropdownIsOpened,
}) => {
  const dropdownRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState('');

  const onClose = () => {
    setDropdownPosition(null);
  };

  useEffect(() => {
    if (dropdownIsOpened) {
      const newPosition = determineDropdownPosition(dropdownRef, containerRef);
      if (newPosition !== dropdownPosition) {
        setDropdownPosition(newPosition);
      }
    }
  }, [dropdownIsOpened, dropdownRef, containerRef]);

  return { dropdownPosition, dropdownRef, onClose };
};
